import React from 'react'

export default function RenderWrite (props) {
  return (
    <h2>{props.text}</h2>
  )
}
